<template>
  <div>
    <CollectionView searchable :endpoint="utilities.path('communities/@/modules/automation/logs', communityId)" v-model:reload="reload" default-order="createdAt:desc">
      <template v-slot:header>
        <h4 class="mb-0">{{ translate("logs") }}</h4>
      </template>
      <template v-slot:content="{ items }">
        <div class="card">
          <div class="table-responsive">
            <div class="table">
              <div class="table-header">
                <div class="table-header-cell">{{ translate("rule") }}</div>
                <div class="table-header-cell">{{ translate("trigger") }}</div>
                <div class="table-header-cell">{{ translate("status") }}</div>
                <div class="table-header-cell">{{ translate("created_at") }}</div>
                <div class="table-header-cell">{{ translate("actions") }}</div>
              </div>
              <div class="table-body">
                <div class="table-row" v-for="item in items" :key="item.id">
                  <div class="table-column">{{ item.rule.name }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center">
                      <i :class="item.details.trigger.icon" class="fa-lg"></i><span class="ms-2">{{ item.details.trigger.title }}</span>
                    </div>
                  </div>
                  <div class="table-column">
                    <AutomationLogStatus :status="item.status"/>
                  </div>
                  <div class="table-column">{{ utilities.formatDatetime(item.createdAt) }}</div>
                  <div class="table-column">
                    <div class="d-flex align-items-center g-2">
                      <ButtonView type="soft" color="primary" size="small" @click="viewId = item.id">
                        <i class="fas fa-eye"></i>
                      </ButtonView>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </CollectionView>
    <ModalView :active="viewId !== undefined" @update:active="viewId = undefined">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between">
          <h3 class="mb-0">{{ translate("automation.log") }}</h3>
          <ModalCloseButtonView @click="viewId = undefined"/>
        </div>
      </template>
      <template v-slot:body>
        <HttpContentView v-if="viewId" :endpoint="utilities.path('modules/automation/logs/@', viewId)">
          <template v-slot:content="{ data: log }">
            <div class="row g-4">
              <div class="col-6">
                <h5 class="mb-2 text-white">{{ translate("automation_rule") }}</h5>
                <ButtonView type="link" color="primary" :route="{ path: 'rules', query: { editId: log.rule.id } }">
                  {{ log.rule.name }}
                </ButtonView>
              </div>
              <div class="col-6">
                <h5 class="mb-2 text-white">{{ translate("status") }}</h5>
                <div>
                  <AutomationLogStatus :status="log.status"/>
                </div>
              </div>
              <div class="col-12">
                <h5 class="mb-3">{{ translate("automation.trigger") }}</h5>
                <div class="card">
                  <div class="card-body p-3">
                    <div class="d-flex align-items-center g-2">
                      <i :class="log.details.trigger.icon" class="fa-lg"></i>
                      <span>{{ log.details.trigger.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12" v-if="log.details">
                <h5 class="mb-3">{{ translate("details") }}</h5>
                <span v-if="log.details.description" class="text-muted small">{{ log.details.description }}</span>
                <div class="d-flex flex-column g-3" v-if="log.details.actions">
                  <div v-for="(action, index) in log.details.actions" :key="index">
                    <div class="card">
                      <div class="card-body p-3">
                        <div class="d-flex align-items-center justify-content-between g-4">
                          <div class="w-100" style="word-wrap: break-word">
                            <div class="d-flex align-items-center g-2">
                              <i class="fa-lg" :class="action.icon"></i>
                              <span>{{ action.title }}</span>
                            </div>
                            <div v-if="action.description" class="text-muted mt-1" style="font-size: 0.8em">
                              {{ action.description }}
                            </div>
                          </div>
                          <div>
                            <i class="fa-lg" :class="{ 'fas fa-check-circle text-success': action.status === 'successful', 'fas fa-exclamation-triangle text-danger': action.status === 'failed' }"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </HttpContentView>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {CollectionView, utilities, ModalView, ButtonView, HttpContentView, ModalCloseButtonView} from "@niftybit/vue";
import AutomationLogStatus from "@/systems/modules/automation/logs/AutomationLogStatus.vue";
import {ref} from "vue";

defineProps({
  communityId: String
});

const reload = ref(false);
const viewId = utilities.routeQueryParam("viewId");

</script>